import React from 'react'
import { Section } from "."

const Introduction = () => {
    return (
        <Section>
            {/* <p className="introduction-text small">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit,
            </p> */}
            <p className="introduction-text">
                &bdquo;Wielcy liderzy są jak najlepsi dyrygenci&ldquo; - Blaine Lee
            </p>
            <p className="introduction-about">
                Świadczymy usługi dostosowane do rosnącego tempa zmian prawnych oraz kultury biznesowej.
                Do grona Naszych klientów należą zarówno wysoce rozwinięte spółki, fundacje czy stowarzyszenia, jak i również mali jednoosobowi przedsiębiorcy.
                Tak szeroki przekrój pozwala Nam na szczegółowe zrozumienie potrzeb współczesnego przedsiębiorcy oraz w odpowiedzi na pojawiające się wyzwania, na wypracowanie adekwatnych rozwiązań.
                Kompleks naszych usług obejmuje wszystkie newralgiczne działania firmy.
                <br />Z Nami zbudujesz od podstaw, rozwiniesz oraz udoskonalisz swój biznes.
            </p>
        </Section>
    )
}

export default Introduction